import React from 'react';

import PropTypes from 'prop-types';
import { RadioGroup } from '@telus-uds/components-web';

import Label from './common/label';
import { useLocalizedStringsContext } from '../../../../context/LocalizedStringsContext';

const DefectCategory = ({
  fieldData,
  setFieldData,
  formErrors,
  setFormErrors
}) => {
  const {
    reportAnIssue: {
      form: {
        labelDefectCategory,
        labelDefectCategoryOptionUserInfo,
        labelDefectCategoryOptionOffersPricing,
        labelDefectCategoryOptionBehaviouralIssue
      }
    }
  } = useLocalizedStringsContext();

  const fieldError = 'defectCategory' in formErrors;
  const fieldOptions = [
    labelDefectCategoryOptionUserInfo,
    labelDefectCategoryOptionOffersPricing,
    labelDefectCategoryOptionBehaviouralIssue
  ];

  const handleSelect = (value) => {
    if (value)
      setFormErrors(previousValue => {
        const updatedValues = { ...previousValue };
        delete updatedValues.defectCategory;
        return updatedValues;
      });
    setFieldData(previousValue => ({
      ...previousValue,
      defectCategory: value
    }));
  };

  // Convert options to RadioGroup items format
  const radioItems = fieldOptions.map(option => ({
    label: option,
    id: option
  }));

  return (
    <div>
      <Label labelName={`${labelDefectCategory} *`} />
      <RadioGroup
        items={radioItems}
        checkedId={fieldData.defectCategory || null}
        onChange={handleSelect}
        name="defectCategory"
        validation={fieldError ? 'error' : undefined}
        feedback={fieldError ? formErrors.defectCategory.message : undefined}
      />
    </div>
  );
};

DefectCategory.propTypes = {
  formErrors: PropTypes.shape({
    defectCategory: PropTypes.shape({
      message: PropTypes.string
    })
  }).isRequired,
  setFormErrors: PropTypes.func.isRequired,
  setFieldData: PropTypes.func.isRequired,
  fieldData: PropTypes.shape({
    defectWebform: PropTypes.string,
    defectCategory: PropTypes.string,
    priority: PropTypes.string,
    issueSummary: PropTypes.string,
    errorMessage: PropTypes.string,
    stepsToReplicate: PropTypes.string,
    attachment: PropTypes.string
  }).isRequired
};

export default DefectCategory;
